<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card title="TOLL DRYING COSTS">
        <template slot="actions">
          <div class="flex gap-2">
            <vs-button
              @click="addNewRow"
              icon-pack="feather"
              icon="icon-plus"
              color="primary"
              type="filled"
            >
              Add New
            </vs-button>

            <vs-button
              @click="saveAll"
              icon-pack="feather"
              icon="icon-save"
              color="success"
              type="filled"
            >
              Save All
            </vs-button>
          </div>
        </template>

        <div class="vx-row mb-6">
          <div class="vx-col">
            <label class="vs-input--label">Minimum Charge (GBP)</label>
          </div>
          <div class="vx-col">
            <vs-input
              @input="updateMinChargeSettings"
              v-model="minCharge"
              size="small"
            />
          </div>
        </div>

        <ValidationObserver ref="form">
          <vs-table stripe class="mt-4" :data="list">
            <template slot="thead">
              <vs-th width="10%">TIER</vs-th>
              <vs-th width="25%">TIER FROM (KG)</vs-th>
              <vs-th width="25%">TIER TO (KG)</vs-th>
              <vs-th width="25%">PRICE (GBP)</vs-th>
              <vs-th width="15%">ACTION</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                v-for="(item, index) in list"
                :key="item.temp_id || item.id"
              >
                <vs-td>
                  {{ index + 1 }}
                </vs-td>

                <vs-td>
                  <ValidationProvider
                    :vid="`min_value_${index}`"
                    :name="`Row ${index + 1} Min Value`"
                    :rules="{
                      required: true,
                      continuous_range: {
                        prevMax: index > 0 ? list[index - 1].max_value : null,
                        rowIndex: index + 1,
                      },
                    }"
                    v-slot="{ errors }"
                  >
                    <vs-input
                      v-model="item.min_value"
                      size="small"
                      class="w-full"
                      :danger="!!errors[0]"
                      :danger-text="errors[0]"
                      val-icon-danger="icon-x"
                      val-icon-pack="feather"
                    />
                  </ValidationProvider>
                </vs-td>

                <vs-td>
                  <ValidationProvider
                    :vid="`max_value_${index}`"
                    :name="`Row ${index + 1} Max Value`"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <vs-input
                      v-model="item.max_value"
                      size="small"
                      class="w-full"
                      :danger="!!errors[0]"
                      :danger-text="errors[0]"
                      val-icon-danger="icon-x"
                      val-icon-pack="feather"
                    />
                  </ValidationProvider>
                </vs-td>

                <vs-td>
                  <vs-input v-model="item.price" size="small" class="w-full" />
                </vs-td>

                <vs-td>
                  <vs-button
                    size="small"
                    color="danger"
                    type="border"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="removeRow(index)"
                  />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </ValidationObserver>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";

const SprayDryCostRepository = RepositoryFactory.get("spray_dry_cost");

export default {
  name: "TollDryingSizes",

  data() {
    return {
      list: [],
      minCharge: "",
    };
  },

  mixins: [SuccessMessage, ErrorMessages],

  async mounted() {
    await this.getSizesList();
    await this.getTollDryingCostSettings();
  },

  methods: {
    async getSizesList() {
      const payload = (
        await SprayDryCostRepository.getTollDryingYieldRangesList()
      ).data;

      this.list = payload.data.sort((a, b) => a.order - b.order);
    },

    async updateTollDryingCostSettings() {
      try {
        this.$vs.loading();
        const payload = {
          min_charge: this.minCharge,
        };
        await SprayDryCostRepository.updateTollDryingCostSettings(payload);
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
      }
    },

    async getTollDryingCostSettings() {
      try {
        const payload = (
          await SprayDryCostRepository.getTollDryingCostSettings()
        ).data;

        this.minCharge = payload.data.min_charge.elements[0].value;
      } catch (error) {}
    },

    updateMinChargeSettings: _.debounce(function () {
      this.updateTollDryingCostSettings();
    }, 350),

    addNewRow() {
      this.list.push({
        temp_id: Date.now(),
        min_value: "",
        max_value: "",
        price: "",
        order: this.list.length + 1,
        is_new: true,
      });
    },

    removeRow(index) {
      this.list.splice(index, 1);
    },

    async saveAll() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) return;

      try {
        this.$vs.loading();

        this.list = this.list.map((item, index) => ({
          ...item,
          order: index + 1,
        }));

        const formattedRanges = this.list.map((item) => {
          const range = {
            min_value: Number(item.min_value),
            max_value: Number(item.max_value),
            price: Number(item.price),
            order: item.order,
          };

          if (item.id) {
            range.id = item.id;
          }

          return range;
        });

        const payload = {
          currency_id: 1,
          ranges: formattedRanges,
        };

        await SprayDryCostRepository.createOrUpdateRanges(payload);

        await this.getSizesList();

        this.$nextTick(() => {
          this.$refs.form.reset();
        });

        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        this.convertAndNotifyError(error);
      }
    },
  },
};
</script>
